var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#0C94FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.1527H34C34.55 32.1527 35 31.6595 35 31.0567C35 30.4538 34.55 29.9606 34 29.9606H18C17.45 29.9606 17 30.4538 17 31.0567C17 31.6595 17.45 32.1527 18 32.1527ZM18 26.6724H34C34.55 26.6724 35 26.1792 35 25.5764C35 24.9735 34.55 24.4803 34 24.4803H18C17.45 24.4803 17 24.9735 17 25.5764C17 26.1792 17.45 26.6724 18 26.6724ZM17 20.0961C17 20.6989 17.45 21.1921 18 21.1921H34C34.55 21.1921 35 20.6989 35 20.0961C35 19.4932 34.55 19 34 19H18C17.45 19 17 19.4932 17 20.0961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.4f734376c4e91204191fe70c4d0fb115.svg";
export { ForwardRef as ReactComponent };